/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { App } from '../../models/app';
import { UpdateLocalizationsDto } from '../../models/update-localizations-dto';

export interface AppLocalizationsControllerUpdate$Params {

/**
 * The app localization id
 */
  id: string;
  
    /**
     * The app localization data to update the user
     */
    body: UpdateLocalizationsDto
}

export function appLocalizationsControllerUpdate(http: HttpClient, rootUrl: string, params: AppLocalizationsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<App>> {
  const rb = new RequestBuilder(rootUrl, appLocalizationsControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<App>;
    })
  );
}

appLocalizationsControllerUpdate.PATH = '/localizations/{id}';
